//include 4
jQuery(function(){
    window.ppComponents = window.ppComponents || {};
    window.ppComponents.sliders = window.ppComponents.sliders || {};

    // Common configuration variables
    var defaultPrevText = "Rückwärts klicken";
    var defaultNextText = "Vorwärts klicken";
    
    // Helper function to generate arrow HTML
    function createArrows(prevText, nextText) {
        return {
            prevArrow: '<button class="prev" title="' + prevText + '" aria-label="' + prevText + '"><i aria-label="' + prevText + '" class="icon-arrow-big-left"></i></button>',
            nextArrow: '<button class="next" title="' + nextText + '" aria-label="' + nextText + '"><i aria-label="' + nextText + '" class="icon-arrow-big-right"></i></button>'
        };
    }
    
    // Common slider base options
    var baseSliderOptions = {
        lazyLoad: 'ondemand',
        autoplaySpeed: 1800,
        cssEase: 'ease-in-out',
        slidesToScroll: 1
    };
    
    // Common responsive breakpoints
    var commonBreakpoints = {
        mobile: 480,
        tablet: 768,
        tabletLarge: 840,
        desktop: 960,
        desktopLarge: 1440
    };

    // Helper function to restore custom accessibility attributes for all elements in slider
    function restoreCustomAccessibilityAttributes($slider) {
        // remove slide tabindex its enought if the slide content is focusable
        $slider.find(".slick-slide[tabindex='0']").each(function() { 
             var $element = $(this); 
             $element.removeAttr("tabindex");
        });

        // Find all elements with custom accessibility attributes within the slider
        $slider.find('[data-tabindex], [data-aria-hidden]').each(function() {
            var $element = $(this); 
            // Restore custom tabindex / aria-hidden if special data-attributes exists
            if ($element.attr('data-tabindex') !== undefined) {
                $element.attr('tabindex', $element.attr('data-tabindex'));
            }
            if ($element.attr('data-aria-hidden') !== undefined) {
                $element.attr('aria-hidden', $element.attr('data-aria-hidden'));
            }
        });
    }

    // Global event handlers for all slick sliders to restore custom accessibility attributes
    $(document).on('init afterChange', '.slick-slider', function(event, slick) {
        var $slider = $(this);
        setTimeout(function() {
            restoreCustomAccessibilityAttributes($slider);
        }, 50);
    });

    // Helper function to initialize sliders with reinitialize capability
    function initializeSlider($element, options) {
        $element.slick(options);
        $element.data("exposed", {
            reinitialize() {
                $element.slick('unslick');
                $element.slick(options);
            }
        });
    }

    // Main slider initialization
    $('.main-slider.slick-slider').each(function () {
        var $this = $(this);
        var prevText = $this.data("prev-text") || defaultPrevText;
        var nextText = $this.data("next-text") || defaultNextText;
        var arrows = createArrows(prevText, nextText);

        var options = $.extend({}, baseSliderOptions, {
            slide: ".item",
            slidesToShow: 1,
            dots: $this.data("dots") !== undefined ? $this.data("dots") : false,
            arrows: $this.data("arrows") !== undefined ? $this.data("arrows") : false,
            autoplay: $this.data("autoplay") !== undefined ? $this.data("autoplay") : false,
            autoplaySpeed: $this.data("autoplay") !== undefined ? $this.data("autoplaySpeed") : 3000
        }, arrows);

        initializeSlider($this, options);
    });

    window.ppComponents.sliders.main = {
        init: function (element) {
            var prevText = element.data("prev-text") || defaultPrevText;
            var nextText = element.data("next-text") || defaultNextText;
            var arrows = createArrows(prevText, nextText);

            var options = $.extend({}, baseSliderOptions, {
                slide: ".item",
                slidesToShow: 1,
                dots: $this.data("dots") !== undefined ? $this.data("dots") : false,
                arrows: $this.data("arrows") !== undefined ? $this.data("arrows") : false,
                autoplay: $this.data("autoplay") !== undefined ? $this.data("autoplay") : false,
                autoplaySpeed: $this.data("autoplay") !== undefined ? $this.data("autoplaySpeed") : 3000
            }, arrows);
            
            if (element.hasClass("slick-initialized"))
                element.slick('unslick');
            element.slick(options);
        }
    };

    // Helper function for read-more initialization
    function initItemsReadMore($slider) {
        return function() {
            setTimeout(function () {
                $slider.find(".more-wrapper").each(function () {
                    var exposed = $slider.data("show-more");
                    if (!!exposed && !!exposed.init) {
                        exposed.init();
                    } else {
                        window.ppComponents.common.showMore($(this));
                    }
                });
            });
        };
    }

    window.ppComponents.sliders.offersGallery = {
        init: function (element) {
            var $this = element;
            var itemCount = $this.find(".item").length;
            var centerMode = itemCount > 3 && !$this.hasClass("no-center-mode");
            var initialSlide = centerMode ? 1 : 0;
            
            var prevText = $this.data("prev-text") || defaultPrevText;
            var nextText = $this.data("next-text") || defaultNextText;
            var arrows = createArrows(prevText, nextText);

            var centerPadding = $this.hasClass("less-center-padding") ? "1px" : "35px";
            var centerPadding2 = $this.hasClass("less-center-padding") ? "1px" : "30px";

            $this.on('init', initItemsReadMore($this));

            var options = $.extend({}, baseSliderOptions, {
                slide: ".item",
                centerMode: centerMode,
                initialSlide: initialSlide,
                centerPadding: centerPadding,
                slidesToShow: 3,
                responsive: [{
                    breakpoint: commonBreakpoints.desktop,
                    settings: {
                        centerPadding: centerPadding2,
                    }
                }, {
                    breakpoint: commonBreakpoints.tabletLarge,
                    settings: {
                        centerMode: false,
                        slidesToShow: 2,
                        initialSlide: 0
                    }
                }, {
                    breakpoint: 640,
                    settings: {
                        centerPadding: '0',
                        centerMode: false,
                        slidesToShow: 1,
                        initialSlide: 0
                    }
                }]
            }, arrows);

            $this.slick(options);
        }
    };

    $('.offers-gallery.slick-slider').each(function () {
        window.ppComponents.sliders.offersGallery.init($(this));
    });

    // Video gallery slider initialization
    $('.videogallery.slick-slider').each(function () {
        var $this = $(this);
        var itemCount = $this.find(".item").length;
        var centerMode = itemCount > 4;
        var initialSlide = centerMode ? 1 : 0;
        var slidesToShow = centerMode ? 4 : itemCount;

        var prevText = $this.data("prev-text") || defaultPrevText;
        var nextText = $this.data("next-text") || defaultNextText;
        var arrows = createArrows(prevText, nextText);

        var options = $.extend({}, baseSliderOptions, {
            slide: ".item",
            centerMode: false, // Always false for video gallery
            initialSlide: 0,   // Always 0 for video gallery
            centerPadding: '35px',
            slidesToShow: slidesToShow,
            responsive: [{
                breakpoint: commonBreakpoints.desktopLarge,
                settings: {
                    slidesToShow: 3,
                    centerMode: centerMode,
                    initialSlide: initialSlide
                }
            }, {
                breakpoint: commonBreakpoints.desktop,
                settings: {
                    centerPadding: '30px',
                }
            }, {
                breakpoint: commonBreakpoints.tablet,
                settings: {
                    centerPadding: '25px',
                    slidesToShow: 2,
                    centerMode: false,
                    initialSlide: 0
                }
            }, {
                breakpoint: commonBreakpoints.mobile,
                settings: {
                    centerPadding: '0',
                    slidesToShow: 1,
                    centerMode: false,
                    initialSlide: 0
                }
            }]
        }, arrows);

        $this.slick(options);
    });


    // Slider box configuration
    var $sliderBoxSlider = $('.slider-box > .slider');
    var prevText = $sliderBoxSlider.data("prev-text") || defaultPrevText;
    var nextText = $sliderBoxSlider.data("next-text") || defaultNextText;
    var arrows = createArrows(prevText, nextText);
    var boxOptions = $.extend({}, baseSliderOptions, {
        slide: "div",
        centerMode: false,
        centerPadding: '35px',
        slidesToShow: 1,
        responsive: [{
            breakpoint: commonBreakpoints.tablet,
            settings: {
                arrows: true,
                centerPadding: '0'
            }
        }]
    }, arrows);

    $sliderBoxSlider.slick(boxOptions);

    // Prospekte box image height adjustment
    $('.slider-box.prospekte-box > .slider').each(function () {
        var elem = $(this);
        var activeSlide = elem.find('div.slick-slide.slick-current.slick-active');
        var imgHeight = activeSlide.width() * 53 / 84;
        elem.find('div.slick-slide img').css("height", imgHeight + "px");

        setTimeout(function () {
            var newImgHeight = activeSlide.find("img").height();
            if (newImgHeight < imgHeight) {
                elem.find('div.slick-slide img').css("height", newImgHeight + "px");
            }
        }, 500);
    });

    window.ppComponents.sliders.sliderBox = {
        init: function (element) {
            var slider = element.find('> .slider');
            if (slider.length > 0) {
                if (slider.hasClass("slick-initialized")) {
                    slider.slick('unslick');
                }
                slider.slick(boxOptions);
            }
        }
    };

    // Adaptive width slider with configurable slides count
    $('.adaptWidthSlider.slick-slider').each(function () {
        var $this = $(this);
        var hasElementsToShow = $this.hasClass("elements-to-show-1") || 
                               $this.hasClass("elements-to-show-2") || 
                               $this.hasClass("elements-to-show-3") || 
                               $this.hasClass("elements-to-show-4");
        
        if (hasElementsToShow && $this.hasClass("slick-initialized")) {
            $this.slick('unslick');
        }

        if (hasElementsToShow && !$this.hasClass("slick-initialized")) {
            // Extract slides count from class name
            var slidesNr = 1;
            var slidesTabletNr = 2;
            
            if ($this.hasClass("elements-to-show-1")) { slidesNr = 1; slidesTabletNr = 1; }
            else if ($this.hasClass("elements-to-show-2")) { slidesNr = 2; }
            else if ($this.hasClass("elements-to-show-3")) { slidesNr = 3; }
            else if ($this.hasClass("elements-to-show-4")) { slidesNr = 4; }

            var prevText = $this.data("prev-text") || defaultPrevText;
            var nextText = $this.data("next-text") || defaultNextText;
            var arrows = createArrows(prevText, nextText);

            var options = $.extend({}, baseSliderOptions, {
                slide: ".item",
                centerMode: false,
                centerPadding: '35px',
                slidesToShow: slidesNr,
                responsive: [{
                    breakpoint: commonBreakpoints.tablet,
                    settings: {
                        centerMode: false,
                        centerPadding: '0',
                        slidesToShow: slidesTabletNr
                    }
                }, {
                    breakpoint: commonBreakpoints.mobile,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1
                    }
                }]
            }, arrows);

            $this.slick(options);
        }
    });


    // General slider with configurable parameters
    $('.general-slider.slick-slider').each(function () {
        var $this = $(this);
        var itemCount = $this.find('>.item').length;
        var showSliderCount = $this.data('slider-shown') || 1;
        var showSliderCountResponsive = showSliderCount >= 2 ? 2 : 1;
        
        // Determine center mode and initial slide
        var centerMode = false;
        var initialSlide = 0;
        if (showSliderCount != 1 && itemCount > 3) {
            centerMode = true;
            initialSlide = 1;
        }

        var prevText = $this.data("prev-text") || defaultPrevText;
        var nextText = $this.data("next-text") || defaultNextText;
        var arrows = createArrows(prevText, nextText);

        var options = $.extend({}, baseSliderOptions, {
            slide: ".item",
            centerMode: centerMode,
            initialSlide: initialSlide,
            slidesToShow: showSliderCount,
            arrows: itemCount > 1,
            responsive: [{
                breakpoint: commonBreakpoints.desktop,
                settings: {
                    centerPadding: '30px',
                }
            }, {
                breakpoint: commonBreakpoints.tabletLarge,
                settings: {
                    centerMode: false,
                    slidesToShow: showSliderCountResponsive,
                    initialSlide: 0
                }
            }, {
                breakpoint: commonBreakpoints.tablet,
                settings: {
                    centerMode: false,
                    centerPadding: '20px',
                    slidesToShow: showSliderCountResponsive,
                    initialSlide: 0
                }
            }, {
                breakpoint: commonBreakpoints.mobile,
                settings: {
                    centerMode: false,
                    centerPadding: '0',
                    slidesToShow: 1,
                    initialSlide: 0
                }
            }]
        }, arrows);

        initializeSlider($this, options);
    });

    // Helper function for slider resize handling
    function handleSliderResize($slider, $subslider) {
        if ($slider && $slider.hasClass('slick-initialized')) {
            $slider.slick('resize');
        }
        if ($subslider && $subslider.hasClass('slick-initialized')) {
            $subslider.slick('resize');
        }
    }

    // Angebot wrapper slider helper functions (from 03angebotWrapperSlider.js)
    function initAngebotRightContent() {
        $(".angebot-wrapper .angebot .info").each(function() {
            var $this = $(this);
            $this.addClass("activated");

            var showMoreWrapper = $this.find(".show-more-wrapper");
            var additionalInfo = $this.find(".additional-info");

            initAngebotRightContentHeight($this);

            setTimeout(function() {
                var threshold = 20;
                if ($this.height() < showMoreWrapper.height()) {
                    additionalInfo.removeClass("hide");
                } else {
                    if ((showMoreWrapper.height() + threshold) < showMoreWrapper[0].scrollHeight) {
                        additionalInfo.removeClass("hide");
                    } else {
                        var padding = $(window).width() >= 640 ? "1.25rem" : "0.8rem";
                        additionalInfo.parent().css("padding-bottom", padding);
                    }
                }
            }, 100);

            setTimeout(function() {
                initAngebotRightContentHeight($this);
            }, 500);

            $this.on("click", ".additional-info", function(e) {
                var sliderWrapper = $(e.target).closest(".slick-slider");
                if (sliderWrapper.length > 0 && sliderWrapper.hasClass("sliding")) return;

                $this.toggleClass("open");

                // Tag manager event (if available)
                if (window.pixelpoint && window.pixelpoint.tagManager) {
                    window.pixelpoint.tagManager.event("Click auf weitere Informationen", {
                        "open": $this.hasClass("open") ? 
                            (window.ppt ? window.ppt.translate("expand", "ausklappen") : "ausklappen") :
                            (window.ppt ? window.ppt.translate("collapse", "einklappen") : "einklappen")
                    });
                }

                if ($(window).width() >= 640) {
                    if ($this.parent().find('.button-open').is(':visible')) {
                        $this.parent().find('.button-open').click();
                    } else {
                        setRightTextHeight($this);
                    }
                } else {
                    setRightTextHeight($this);
                }
            });

            if ($(window).width() < 640) {
                $this.find('div.showmore').addClass('collapsed');
                var prices = $this.find('div.prices');
                if (prices.hasClass("addOpen")) {
                    prices.addClass('transparent-gradient open');
                } else {
                    prices.addClass('transparent-gradient');
                    if (window.initPriceReadMore) {
                        window.initPriceReadMore();
                    }
                }
            }
        });
    }

    function initAngebotRightContentHeight($this) {
        var columnText = $this.parent().find('.text-col');
        var columnTextHeight = columnText.outerHeight();
        var columnPicture = $this.parent().find('.picture');
        var columnPictureHeight = columnPicture.outerHeight();

        var usedInfoHeight = 0;
        if ($(window).width() <= 960 && columnText.outerWidth() == columnPicture.outerWidth()) {
            usedInfoHeight = columnPictureHeight + columnTextHeight;
        } else if (columnTextHeight > columnPictureHeight) {
            usedInfoHeight = columnTextHeight;
        } else {
            usedInfoHeight = columnPictureHeight;
        }

        if ($(window).width() >= 640) {
            $this.css({
                "max-height": usedInfoHeight,
                "height": usedInfoHeight,
                "min-height": usedInfoHeight
            });
        }
    }

    function setRightTextHeight($this) {
        var angebotTextHeight = $this.parent().find('.text-col').outerHeight();
        var heightInfo = 0;
        var maxHeightInfo = 0;
        var minHeightInfo = parseInt($this.css('min-height'));

        $this.removeAttr("style");

        if ($this.hasClass("open")) {
            heightInfo = ($(window).width() >= 640 && $this.height() <= angebotTextHeight) ? 
                        angebotTextHeight : 'auto';
            maxHeightInfo = 'none';
        } else {
            maxHeightInfo = minHeightInfo;
        }

        $this.css({
            "height": heightInfo,
            "max-height": maxHeightInfo,
            "min-height": minHeightInfo
        });
    }

    // Angebot wrapper slider initialization (from 03angebotWrapperSlider.js)
    const initializeAngebotSlider = () => {
        // re-query the live DOM here instead of using a selector captured at DOM-ready
        var $angebotSlider = $('.angebot-wrapper > .slick-slider');
        if (!$angebotSlider.length) return;

        var prevText = $angebotSlider.data("prev-text") || defaultPrevText;
        var nextText = $angebotSlider.data("next-text") || defaultNextText;
        var arrows = createArrows(prevText, nextText);

        var angebotOptions = $.extend({}, baseSliderOptions, {
            slide: ".angebot",
            centerMode: false,
            centerPadding: '30px',
            slidesToShow: 1,
            autoplay: false,
            init: function(event, slick) {
                // Add overlay divs
                $(event.target).find(">div.slick-list")
                    .append('<div class="hide-slide left"></div><div class="hide-slide right"></div>')
                    .addClass("overflow-content");
            }
        }, arrows);

        $angebotSlider.not('.slick-initialized').slick(angebotOptions);

        // Set min-height for mobile
        if ($(window).width() < 640) {
            var stHeight = $('.angebot-wrapper .slick-slider .slick-track').height();
            $('.angebot-wrapper .slick-slider .slick-slide').css('min-height', stHeight + 'px');
        }

        initAngebotRightContent();

        // Show more wrapper event handlers
        $(".angebot-wrapper .angebot .more-wrapper").each(function() {
            var $this = $(this);
            var angebot = $this.closest(".angebot");
            var info = angebot.find(".info");
            var showMore = $this.data("show-more");

            if (showMore && $(window).width() >= 640) {
                showMore.on("toggle", function() {
                    info.toggleClass("open", $this.hasClass('open'));
                    setRightTextHeight(info);
                });

                showMore.on("toggleEnd", function() {
                    setRightTextHeight(info);
                });
            }
        });

        // Resize handler
        $(window).on("orientationchange resize", initAngebotRightContent);

        // Slider event handlers
        $angebotSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $(event.target).addClass("sliding");
            $(event.target).find("div.angebot .info").removeClass("open");
        });

        $angebotSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            var element = $(event.target);
            element.removeClass("sliding");
            var showMore = element.find('div.slick-current').find(".offer-content");
            var showMoreApi = showMore.data("show-more");
            if (showMoreApi && showMoreApi.init) {
                showMoreApi.init();
            }
        });
    };

    // Initialize angebot slider on window load
    $(window).on("load", initializeAngebotSlider);

    // Content slider initialization (from 04contentSlider.js)
    const initializeContentSliders = () => {
        // re-query the live DOM here - same reasoning as initializeAngebotSlider above
        var $contentSlider = $('.content-slider > .slick-slider');
        var $contentSubslider = $('.content-sub-slider > .slick-slider');
        if (!$contentSlider.length && !$contentSubslider.length) return;

        // Main content slider
        var prevText = $contentSlider.data("prev-text") || defaultPrevText;
        var nextText = $contentSlider.data("next-text") || defaultNextText;
        var arrows = createArrows(prevText, nextText);

        var contentOptions = $.extend({}, baseSliderOptions, {
            slide: "div",
            centerMode: false,
            centerPadding: '35px',
            slidesToShow: 1,
            autoplay: false,
            asNavFor: '.content-sub-slider > .slick-slider',
            responsive: [{
                breakpoint: commonBreakpoints.tablet,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }, {
                breakpoint: commonBreakpoints.mobile,
                settings: {
                    centerMode: false,
                    centerPadding: '0px',
                    slidesToShow: 1
                }
            }]
        }, arrows);

        // Sub-slider options
        var subsliderOptions = $.extend({}, baseSliderOptions, {
            slide: "div",
            centerMode: false,
            centerPadding: '35px',
            arrows: false,
            asNavFor: '.content-slider > .slick-slider',
            slidesToShow: 3,
            autoplay: false
        });

        $contentSlider.not('.slick-initialized').slick(contentOptions);
        $contentSubslider.not('.slick-initialized').slick(subsliderOptions);

        // Sub-slider click handler
        $contentSubslider.on('click', 'div.item', function() {
            var index = $(this).data('slick-index');
            var actualSliderItems = $(this).parent().find("div.item").length;

            if (actualSliderItems > 4) {
                $contentSubslider.slick('slickGoTo', index + 1);
            } else {
                $contentSlider.slick('slickGoTo', index);
            }
        });

        // Resize handlers
        $(window).on('resize orientationchange', function() {
            handleSliderResize($contentSlider, $contentSubslider);
        });
    };

    // Initialize content sliders on window load
    $(window).on("load", initializeContentSliders);
});